export const enum SignInStageEnum {
    SIGN_IN = "signIn",
    ACTIVATE = "activate",
    CHANGE_PASSWORD = "changePassword",
    OTP ="otp",
    FORGET_PASSWORD = "forgetPassword",
    FORGET_PASSWORD_OTP = "otp_forgetPassword",
    RESET_PASSWORD="reset_password"
}